import { connect } from 'react-redux';
import Footer from './Footer';
import { createLead } from '../../actions/leads';

const mapState = (state, props) => ({
  ...props,
  userEmail: state.fenderConnect && state.fenderConnect.email ? state.fenderConnect.email : null,
  requestInProgress: state.leads.requestInProgress,
  leadsSuccessStatus: state.leads.leadsSuccessStatus,
  leadsErrorStatus: state.leads.leadsErrorStatus,
});

const mapDispatch = {
  createLead,
};

export default connect(
  mapState,
  mapDispatch,
)(Footer);
